import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'rogueCaseRecommendation'
})
export class RogueCaseRecommendationPipe implements PipeTransform {

  private recommendations = [
    'SCRAP',
    'DEEP_DIVE',
    'DEEP_DIVE_SCRAP_NFF',
    'ACCEPT_PERFORMANCE',
    'REDISCUSS',
    'NOT_EVALUATED',
    'EXCHANGE',
    'UNHD_HOLD',
    'VENDOR_EVAL_WARRANTY',
    'VENDOR_EVAL_SCRAP',
  ];

  transform(value: string | null | undefined): unknown {
    if (!!value && this.recommendations.includes(`${value}`)) {
      let returnValue = '';

      if (value === 'UNHD_HOLD') {
        return 'UNHD Hold';
      }

      if (value === 'DEEP_DIVE_SCRAP_NFF') {
        return 'Deep Dive: Scrap NFF';
      }

      if (value === 'VENDOR_EVAL_WARRANTY') {
        return 'Vendor Eval: Warranty';
      }

      if (value === 'VENDOR_EVAL_SCRAP') {
        return 'Vendor Eval: Scrap';
      }

      `${value}`.toLowerCase().split('_').forEach(partial => {
        returnValue = returnValue + ' ' + partial.charAt(0).toUpperCase() + partial.slice(1);
      });

      return returnValue;
    }

    return null;
  }

}
